import { render, staticRenderFns } from "./ModalEditPartner.vue?vue&type=template&id=3806f0dc&"
import script from "./ModalEditPartner.vue?vue&type=script&lang=ts&"
export * from "./ModalEditPartner.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports